var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isBoolean } from 'lodash';
export var isEmpty = function (obj) {
    return Object.entries(obj).length === 0 && obj.constructor === Object;
};
export var arrayToObjParams = function (arr) {
    return arr.reduce(function (prev, next) {
        prev[next.name] = next.value;
        return prev;
    }, {});
};
export var bfs = function (node, searchTerm, path) {
    if (path === void 0) { path = []; }
    if (!node.type) {
        if (node.id === searchTerm) {
            return __spreadArrays(path);
        }
        return null;
    }
    for (var i = 0; i < node.children.length; i++) {
        var n = node.children[i];
        if (n.id === searchTerm) {
            return __spreadArrays(path);
        }
    }
    for (var i = 0; i < node.children.length; i++) {
        var n = node.children[i];
        var result = bfs(n, searchTerm, __spreadArrays(path, [n.id]));
        if (result) {
            return result;
        }
    }
    return null;
};
var zeroCorrection = function (num) { return (num > 9 ? num : "0" + num); };
export var seconds = function (time) {
    var sec = Math.floor(time / 1000) % 60;
    return zeroCorrection(sec);
};
export var minutes = function (time) {
    var min = Math.floor((time / (1000 * 60)) % 60);
    return zeroCorrection(min);
};
export var hours = function (time) {
    var hours = Math.floor(time / (1000 * 60 * 60));
    return zeroCorrection(hours);
};
export var isTrue = function (val) {
    if (isBoolean(val)) {
        return val;
    }
    return val === 'true';
};
export var isFalse = function (val) {
    if (isBoolean(val)) {
        return !val;
    }
    return val === 'false';
};
export var convertIdToCssSelectorId = function (id) {
    return id.replace(/[&\/\\#, +()$~%.’“:*?\[\]<>{}\n]/g, '_');
};
//# sourceMappingURL=utils.js.map